export default function scrollToTop(element, data) {
    const keyword = element.querySelector(".keyword");
    const filterable = element.querySelectorAll(".filterable");

    if (keyword) {
        keyword.addEventListener("input", function () {
            const value = keyword.value;
            for (const el of filterable) {
                const text = el.dataset.text;

                if (text.toLowerCase().includes(value.toLowerCase())) {
                    el.style.display = "block";
                } else {
                    el.style.display = "none";
                }
            }
        });
    }
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary